import { PROFILE__MUTATIONS } from "../mutation-types";
import { PROFILE__ACTIONS } from "../action-types";
import { PROFILE__API } from "@/_helpers/urls";
import http from "@/_helpers/http";
import toast from "@/services/Notification";

// State
const state = {
  profile: null,
  tutorials: null,
  documentInfo: {
    identityVerification: "",
    residenceVerification: "",
    identityVerificationDocuments: [],
    residenceVerificationDocuments: [],
  },
};

const getters = {
  isValidToChangePassword(state) {
    if (
      state.password &&
      state.confirm_password &&
      state.password == state.confirm_password
    )
      return true;
    return false;
  },
};

// Mutations
const mutations = {
  [PROFILE__MUTATIONS.PROFILE](state, data) {
    state.profile = data;
  },
  [PROFILE__MUTATIONS.GETTUTORIALS](state, data) {
    state.tutorials = data;
  },
  [PROFILE__MUTATIONS.IDENTITYVERIFICATION](state, payload) {
    state.documentInfo.identityVerification = payload;
  },
  [PROFILE__MUTATIONS.RESIDENCEVERIFICATION](state, payload) {
    state.documentInfo.residenceVerification = payload;
  },
  [PROFILE__MUTATIONS.IDENTITYVERIFICATIONDOCUMENTS](state, payload) {
    state.documentInfo.identityVerificationDocuments = payload;
  },
  [PROFILE__MUTATIONS.RESIDENCEVERIFICATIONDOCUMENTS](state, payload) {
    state.documentInfo.residenceVerificationDocuments = payload;
  },
};

// Actions
const actions = {
  async [PROFILE__ACTIONS.PROFILE]({ commit }) {
    try {
      const { data } = await http().get(PROFILE__API.PROFILE);
      commit(PROFILE__MUTATIONS.PROFILE, data);
    } catch (error) {
      console.error("Error fetching profile:", error);
    }
  },

  async [PROFILE__ACTIONS.GETTUTORIALS]({ commit }) {
    try {
      const response = await http().get(PROFILE__API.GETTUTORIALS);
      commit(PROFILE__MUTATIONS.GETTUTORIALS, response.data);
    } catch (error) {
      console.log(error);
    }
  },

  async [PROFILE__ACTIONS.CHANGETHEME]({ dispatch }, data) {
    try {
      const url = `${PROFILE__API.CHANGETHEME}`;
      const response = await http().post(url, data);

      if (response.status === 200) {
        dispatch(PROFILE__ACTIONS.PROFILE);
        toast.success(response.data.message);
        return {
          success: true,
          status: 200,
        };
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed To Update Theme");
      return {
        success: false,
        status: error.response?.status || 500,
      };
    }
  },

  async [PROFILE__ACTIONS.FETCHDOCUMENTS]({ commit }) {
    try {
      const response = await http().get(PROFILE__API.FETCHDOCUMENTS);

      if (response.status === 200) {
        const { identityDocument, residenceDocument } = response.data;

        commit(
          PROFILE__MUTATIONS.IDENTITYVERIFICATIONDOCUMENTS,
          identityDocument
        );
        commit(
          PROFILE__MUTATIONS.RESIDENCEVERIFICATIONDOCUMENTS,
          residenceDocument
        );
      } else {
        const errorMessage = response.data.message;
        toast.error(errorMessage);
      }
    } catch (error) {
      console.error("An error occurred while fetching documents:", error);
    }
  },

  async [PROFILE__ACTIONS.IDENTITYVERIFICATION]({ commit, dispatch }, data) {
    try {
      const response = await http().post(
        PROFILE__API.IDENTITYVERIFICATION,
        data
      );

      if (response.data.status === 200) {
        commit(
          PROFILE__MUTATIONS.IDENTITYVERIFICATION,
          response.data.documentUrl
        );
        await dispatch(PROFILE__ACTIONS.FETCHDOCUMENTS);
        toast.success(response.data.message);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error(error);
    }
  },

  async [PROFILE__ACTIONS.RESIDENCEVERIFICATION](
    { commit, state, dispatch },
    data
  ) {
    try {
      const response = await http().post(
        PROFILE__API.RESIDENCEVERIFICATION,
        data
      );

      if (response.data.status === 200) {
        commit(
          PROFILE__MUTATIONS.RESIDENCEVERIFICATION,
          response.data.documentUrl
        );
        await dispatch(PROFILE__ACTIONS.FETCHDOCUMENTS);
        toast.success(response.data.message);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error(error);
    }
  },
};

export default {
  strict: process.env.NODE_ENV !== "production",
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
